import MUserSelectionTable from './index.vue';

MUserSelectionTable.install = app => {
  app.component(MUserSelectionTable.name, MUserSelectionTable);
};

export default MUserSelectionTable;
